import type { ComponentType } from 'react';
import GallectionsEmptyState from './GallectionsEmptyState';
import GallectionsEmptyStateContainer, {
  OwnProps,
} from './GallectionsEmptyState.container';

export default GallectionsEmptyStateContainer(
  GallectionsEmptyState
) as ComponentType<OwnProps>;
